// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get } from "./api_client";
import { AuditLogResult, IAuditLogResult } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getAuditLogs(limit: number, sortKey?: string, sortDirection?: string, userId?: string, userName?: string, traceId?: string, dateFrom?: Date, dateTo?: Date, httpMethod?: string, controllerName?: string, actionName?: string, cursor?: string): ApiResult<AuditLogResult> {
		const queryParams = [limit !== undefined ? `limit=${limit}` : undefined,
			sortKey !== undefined ? `sortKey=${sortKey}` : undefined,
			sortDirection !== undefined ? `sortDirection=${sortDirection}` : undefined,
			userId !== undefined ? `userId=${userId}` : undefined,
			userName !== undefined ? `userName=${userName}` : undefined,
			traceId !== undefined ? `traceId=${traceId}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined,
			httpMethod !== undefined ? `httpMethod=${httpMethod}` : undefined,
			controllerName !== undefined ? `controllerName=${controllerName}` : undefined,
			actionName !== undefined ? `actionName=${actionName}` : undefined,
			cursor !== undefined ? `cursor=${cursor}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IAuditLogResult>(`/api/auditlogs/${query}`).then(result => result === undefined ? undefined :  new AuditLogResult(result));
}
